import { BaseService } from "./baseService";
class UserService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "user";
    }
}
export const userService = new UserService();
//# sourceMappingURL=userService.js.map